<template>
<div class="nkn-member">
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12">
      <div class="common-title">{{$t("about.member.title")}}</div>
    </div>
  </div>
  <div class="nkn-team-body">
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-3" :class="'en' === lang ? 'desc-long':''">
        <team-module>
          <img v-lazy="'/static/img/about/coreTeam/Yanbo.png'" slot="title-img" class="pic-team-Yanbo" >
          <span slot="title-text">{{$t("about.member.yanbo.name")}}</span>
          <div slot="position">{{$t("about.member.yanbo.position1")}}</div>
          <div slot="position">{{$t("about.member.yanbo.position2")}}</div>
          <p slot="detail">{{$t("about.member.yanbo.intro")}}</p>
          <a :href="$url.TEAM_LINK.github.yanbo" target="_blank" slot="github"><i class="icon iconfont icon-github-radio"></i></a>
          <a :href="$url.TEAM_LINK.linkedin.yanbo" target="_blank" slot="linkedin"><i class="icon iconfont icon-linkedin"></i></a>
        </team-module>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-3" :class="'en' === lang ? 'desc-long':''">
        <team-module>
          <img v-lazy="'/static/img/about/coreTeam/Bruce.png'" slot="title-img" class="pic-team-Bruce" >
          <div slot="title-text" class="show-in-one-rows">{{$t("about.member.bruce.firstname")}} {{$t("about.member.bruce.lastname")}}</div>
          <div slot="title-text" class="show-in-two-rows">{{$t("about.member.bruce.firstname")}}</div>
          <div slot="title-text" class="show-in-two-rows">{{$t("about.member.bruce.lastname")}}</div>

          <div slot="position">{{$t("about.member.bruce.position1")}}</div>
          <div slot="position">{{$t("about.member.bruce.position2")}}</div>
          <p slot="detail">{{$t("about.member.bruce.intro")}}</p>
          <a :href="$url.TEAM_LINK.linkedin.bruce" target="_blank" slot="linkedin"><i class="icon iconfont icon-linkedin"></i></a>
        </team-module>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-3">
        <team-module>
          <img v-lazy="'/static/img/about/coreTeam/Yilun.png'" slot="title-img" class="pic-team-Yilun" >
          <span slot="title-text">{{$t("about.member.yilun.name")}}</span>
          <div slot="position">{{$t("about.member.yilun.position1")}}</div>
          <div slot="position">{{$t("about.member.yilun.position2")}}</div>
          <p slot="detail">{{$t("about.member.yilun.intro")}}</p>
          <a :href="$url.TEAM_LINK.github.yilun" target="_blank" slot="github"><i class="icon iconfont icon-github-radio"></i></a>
          <a :href="$url.TEAM_LINK.linkedin.yilun" target="_blank" slot="linkedin"><i class="icon iconfont icon-linkedin"></i></a>
        </team-module>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-3">
        <team-module>
          <img v-lazy="'/static/img/about/coreTeam/Allen.png'" slot="title-img" class="pic-team-Allen" >
          <span slot="title-text">{{$t("about.member.allen.name")}}</span>
          <div slot="position">{{$t("about.member.allen.position1")}}</div>
          <div slot="position">{{$t("about.member.allen.position2")}}</div>
          <p slot="detail">{{$t("about.member.allen.intro")}}</p>
          <a :href="$url.TEAM_LINK.linkedin.allen" target="_blank" slot="linkedin"><i class="icon iconfont icon-linkedin"></i></a>
        </team-module>
      </div>
    </div>
  </div>
  <!-- <div class="nkn-adviser-body">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6">
        <adviser-module>
          <img v-lazy="'/static/img/about/adviser/diffie.png'" slot="portrait" class="pic-adviser-diffie">
          <a slot="fullname" :href="$url.ADVISER_LINK.diffie" target="_blank">{{$t("about.member.diffle.name")}}</a>
          <div slot="honor">{{$t("about.member.diffle.honor1")}}</div>
          <div slot="honor">{{$t("about.member.diffle.honor2")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row1")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row2")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row3")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row4")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row5")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row6")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row7")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row8")}}</div>
          <div slot="honor-detail">{{$t("about.member.diffle.honorlist.row9")}}</div>
        </adviser-module>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 adviser-Wolfram">
        <adviser-module>
          <img v-lazy="'/static/img/about/adviser/Wolfram.png'" slot="portrait" class="pic-adviser-Wolfram">
          <a slot="fullname" :href="$url.ADVISER_LINK.wolfram" target="_blank">{{$t("about.member.wolfram.name")}}</a>
          <div slot="honor">{{$t("about.member.wolfram.honor1")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row1")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row2")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row3")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row4")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row5")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row6")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row7")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row8")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row9")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row10")}}</div>
          <div slot="honor-detail">{{$t("about.member.wolfram.honorlist.row11")}}</div>
        </adviser-module>
      </div>
    </div>
  </div> -->
</div>
</template>

<script>
import TeamModule from '@/components/about/plugins/TeamModule'
// import AdviserModule from '@/components/about/plugins/AdviserModule'
export default {
  components: {
    TeamModule
    // AdviserModule

  },
  computed: {
    lang() {
      return this.$i18n.locale
    }
  }
}
</script>

<style lang="scss" scoped>
.nkn-member {
  @include common-inner();

  // p {
  //   word-break: break-all !important;
  //   word-wrap: break-word !important;
  // }
  .show-in-one-rows {
    display: none;
  }
  .show-in-two-rows {
    display: block;
  }
  .nkn-team-body {
    margin-top: 5rem;
    @media screen and (max-width: 768px) {
      margin: 0 auto;
      p {
        padding-right: .5rem;
      }

      .show-in-one-rows {
        display: block;
      }
      .show-in-two-rows {
        display: none;
      }

      .desc-long {
        .team-module {
          height: 500px;
        }
      }
    }
  }

  // .nkn-adviser-body {
  //   margin-top: 3rem;
  //   padding-right: .9rem;
  //   @media screen and (max-width: 768px) {
  //     padding: 0;
  //   }
  // }

}
</style>



// WEBPACK FOOTER //
// src/components/about/nknCoreTeam.vue